<script setup lang="ts">
import { computed } from 'vue';
import { Textarea } from '@/shared/ui';
import { OBSERVATIONS_MAX_LENGTH } from '../../model/editHomologation.constants';

const props = withDefaults(
  defineProps<{
    hasTraining?: boolean;
  }>(),
  {
    hasTraining: true,
  }
);

const observations = defineModel<string | undefined>();

const currentLength = computed(() => (observations.value ?? '').length);

const label = computed(() => (props.hasTraining ? 'Observações' : 'Justifique:'));

const placeholder = computed(() =>
  props.hasTraining
    ? 'Descreva as observações inerentes a este documento (opcional)'
    : 'Explique porque não será necessário o treinamento'
);
</script>

<template>
  <div class="flex flex-col gap-3 p-6">
    <h3 class="text-sm font-semibold text-gray-07">
      {{ label }} <span
        v-if="!hasTraining"
        class="text-red-16"
      >*</span>
    </h3>
    <Textarea
      v-model="observations"
      :placeholder="placeholder"
      class="min-h-24"
      :maxlength="OBSERVATIONS_MAX_LENGTH"
    />
    <p class="text-xs text-gray-07">
      {{ currentLength }}/{{ OBSERVATIONS_MAX_LENGTH }} caracteres
    </p>
  </div>
</template>
